import API from "./API";

export default class NPCs extends API {
  constructor(gateway) {
    super(gateway, 'npc')
  }
}
